module.exports = __webpack_public_path__ + "static/media/banner_01.db4df46d.png";